import React from "react";
import { Card, Badge } from "react-bootstrap";

/**
 * NumberCard Component
 *
 * Props:
 * - chartData: The data to display { Title, Amount (number), Date? }
 * - AmountName: The name of the amount field
 * - TitleName: The name of the title field
 * - DateName: The name of the date field
 * - dataType: The data type of the amount field (number | currency | percentage)
 */
const NumberCard = ({
  chartData,
  AmountName = "Amount",
  TitleName = "Title",
  DateName = "Date",
  dataType = "number",
}) => {
  if (!chartData) {
    return null;
  }

  const {
    [AmountName]: Amount,
    [TitleName]: Title,
    [DateName]: Date,
  } = chartData;

  // Create formatter based on dataType
  const getFormatter = () => {
    switch (dataType) {
      case "currency":
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      case "percentage":
        return new Intl.NumberFormat("en-US", {
          style: "percent",
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
      case "number":
      default:
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
    }
  };

  const formatter = getFormatter();

  const valueToFormat =
    dataType === "percentage" && typeof Amount === "number"
      ? Amount / 100
      : Amount;

  const formattedAmount = formatter.format(valueToFormat);

  return (
    <Card className="h-100" style={{ boxShadow: "none" }}>
      <Card.Body className="py-3 text-center d-flex flex-column justify-content-center">
        <div className="fw-medium fs-8">{formattedAmount}</div>
        <div className="text-muted mb-2">
          <div>{Title}</div>
          {chartData.Subtitle && <div>{chartData.Subtitle}</div>}
        </div>
        {Date && (
          <Badge className="mx-auto" bg="warning">
            {Date}
          </Badge>
        )}
      </Card.Body>
    </Card>
  );
};

export default NumberCard;
